import React, { useState } from "react";
import { DueDateDisplay } from "./DueDateDisplay";
import { DueDateDisplayModal } from "./DueDateDisplayModal";

export type Props = {
  dueDate?: Date;
  enableEdit: boolean;
  feedbackCode: string;
  onChange: (feedbackCode: string, newDueDate: Date | undefined) => void;
};

export const DueDateDisplayContainer = (props: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  return (
    <>
      <DueDateDisplay {...props} onClickEdit={toggleModal} />
      <DueDateDisplayModal {...props} isOpen={isModalOpen} toggleModal={toggleModal} />
    </>
  );
};
